export class PlayerState {
  player: Uint8Array;             // 32 bytes
  randomness_account: Uint8Array; // 32 bytes
  commit_slot: bigint;
  in_progress: number;            // Borsh will treat bool as u8
  last_dice_1: number;
  last_dice_2: number;

  constructor(fields: {
    player: Uint8Array,
    randomness_account: Uint8Array,
    commit_slot: bigint,
    in_progress: number,
    last_dice_1: number,
    last_dice_2: number
  }) {
    this.player = fields.player;
    this.randomness_account = fields.randomness_account;
    this.commit_slot = fields.commit_slot;
    this.in_progress = fields.in_progress;
    this.last_dice_1 = fields.last_dice_1;
    this.last_dice_2 = fields.last_dice_2;
  }
}

/**
 * Borsh schema describing how to read/write our PlayerState class.
 */
export const PlayerStateSchema = new Map([
  [
    PlayerState,
    {
      kind: "struct",
      fields: [
        ["player", [32]],              // 32-byte pubkey
        ["randomness_account", [32]],  // 32-byte pubkey
        ["commit_slot", "u64"],        // 8 bytes
        ["in_progress", "u8"],         // bool in Rust typically stored as u8
        ["last_dice_1", "u8"],         // 1 byte
        ["last_dice_2", "u8"],         // 1 byte
      ],
    },
  ],
]);
